import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-250733c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-venues relative mt-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppVenue = _resolveComponent("AppVenue")!
  const _component_VenueDetail = _resolveComponent("VenueDetail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.venues, (venue) => {
      return (_openBlock(), _createBlock(_component_AppVenue, {
        key: venue.uuid,
        venue: venue
      }, null, 8, ["venue"]))
    }), 128)),
    (_ctx.detailVenue)
      ? (_openBlock(), _createBlock(_component_VenueDetail, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}